module.exports = __webpack_public_path__ + "static/scale-model-of-san-agustin-cathedral-in-laredo-texas-9683ab61b7b71b6e373659d697772bbc.png";